import * as api from '@/api'

const selfcheck = {
  namespaced: true,
  state: {
    seatType: -1, // 0:テーブル 1:カウンター
    checkStatus: -1, // 0:会計可能 1:セルフ未対応 2:タブレット会計中 9:会計完了
    checkInfos: [],
    taxAmount: 0, // 税込価格
    amountChanged: 0, // 0:金額変更なし 1:金額変更あり
    annaiMoviePauseMs: 0, // ms
    annaiMoviePlayMs: 0, // ms
    isFetching: false,
    error: null,
  },
  getters: {
    getSeatType: (state) => state.seatType,
    getCheckStatus: (state) => state.checkStatus,
    getIsSelfcheckReady: (state) => state.checkStatus === 0,
    getCheckInfos: (state) => state.checkInfos,
    getTaxAmount: (state) => state.taxAmount,
    getIsAmountChanged: (state) => state.amountChanged === 1,
    getIsFetching: (state) => state.isFetching,
    getIsTable: (state) => state.seatType === 0,
    getError: (state) => state.error,
  },
  actions: {
    initSelfcheck: async ({ commit, dispatch, rootGetters }) => {
      const token = rootGetters['auth/getToken']
      const shopId = rootGetters['seat/getShopId']
      const seatNo = rootGetters['seat/getSeatNo']
      commit('initSelfcheckStart')
      try {
        const res = await api.initSelfcheck(token, shopId, seatNo)
        if (res.data.checkStatus !== 0) {
          dispatch('modal/setShowingCheckingOutModal', true, { root: true })
        }
        dispatch('seat/setCashRegisterType', res.data.cashRegisterType, { root: true })
        commit('initSelfcheckDone', res.data)
      } catch (error) {
        commit('initSelfcheckFailed', error)
      }
    },
    updateSelfcheckCount: async ({ commit, rootGetters }) => {
      const token = rootGetters['auth/getToken']
      const shopId = rootGetters['seat/getShopId']
      const seatNo = rootGetters['seat/getSeatNo']
      commit('updateSelfcheckCountStart')
      try {
        await api.updateSelfcheckCount(token, shopId, seatNo)
        commit('updateSelfcheckCountDone')
      } catch (error) {
        commit('updateSelfcheckCountFailed', error)
      }
    },
    createSelfcheckAmount: async ({ commit, rootGetters }) => {
      const token = rootGetters['auth/getToken']
      const shopId = rootGetters['seat/getShopId']
      const seatNo = rootGetters['seat/getSeatNo']
      commit('createSelfcheckAmountStart')
      try {
        const res = await api.createSelfcheckAmount(token, shopId, seatNo)
        commit('createSelfcheckAmountDone', res.data)
      } catch (error) {
        commit('createSelfcheckAmountFailed', error)
      }
    },
    confirmSelfcheck: async ({ commit, rootGetters }) => {
      const token = rootGetters['auth/getToken']
      const shopId = rootGetters['seat/getShopId']
      const seatNo = rootGetters['seat/getSeatNo']
      commit('confirmSelfcheckStart')
      try {
        const res = await api.confirmSelfcheck(token, shopId, seatNo)
        commit('confirmSelfcheckDone', res.data)
      } catch (error) {
        commit('confirmSelfcheckFailed', error)
      }
    },
    cancelSelfcheck: async ({ commit, rootGetters }, { callStaff }) => {
      const shopId = rootGetters['seat/getShopId']
      const seatNo = rootGetters['seat/getSeatNo']
      commit('cancelSelfcheckStart')
      try {
        await api.cancelSelfcheck(shopId, seatNo, callStaff)
        commit('cancelSelfcheckDone')
      } catch (error) {
        commit('cancelSelfcheckFailed', error)
      }
    },
    fetchSeatAmount: async ({ commit, rootGetters }) => {
      const token = rootGetters['auth/getToken']
      const shopId = rootGetters['seat/getShopId']
      const seatNo = rootGetters['seat/getSeatNo']
      commit('fetchSeatAmountStart')
      try {
        const res = await api.fetchSeatAmount(token, shopId, seatNo)
        commit('fetchSeatAmountDone', res.data)
      } catch (error) {
        commit('fetchSeatAmountFailed', error)
      }
    },
    callStaffSelfcheck: async ({ commit, rootGetters }) => {
      const token = rootGetters['auth/getToken']
      const shopId = rootGetters['seat/getShopId']
      const seatNo = rootGetters['seat/getSeatNo']
      commit('callStaffSelfcheckStart')
      try {
        const res = await api.callStaffSelfcheck(token, shopId, seatNo)
        commit('callStaffSelfcheckDone', res.data)
      } catch (error) {
        commit('callStaffSelfcheckFailed', error)
        return error
      }
    },
  },
  mutations: {
    initSelfcheckStart(state) {
      state.error = null
      state.isFetching = true
    },
    initSelfcheckDone(state, payload) {
      state.seatType = payload.seatType
      state.checkStatus = payload.checkStatus
      state.isFetching = false
    },
    initSelfcheckFailed(state, error) {
      state.error = error
      state.isFetching = false
    },
    updateSelfcheckCountStart(state) {
      state.error = null
      state.isFetching = true
    },
    updateSelfcheckCountDone(state) {
      state.isFetching = false
    },
    updateSelfcheckCountFailed(state, error) {
      state.error = error
      state.isFetching = false
    },
    createSelfcheckAmountStart(state) {
      state.error = null
      state.isFetching = true
    },
    createSelfcheckAmountDone(state, payload) {
      state.checkInfos = payload.checkInfos
      state.taxAmount = payload.taxAmount
      state.amountChanged = payload.amountChangedFlg
      state.isFetching = false
    },
    createSelfcheckAmountFailed(state, error) {
      state.error = error
      state.isFetching = false
    },
    confirmSelfcheckStart(state) {
      state.error = null
      state.isFetching = true
    },
    confirmSelfcheckDone(state, payload) {
      state.checkInfos = payload.checkInfos
      state.taxAmount = payload.taxAmount
      state.amountChanged = payload.amountChangedFlg
      state.isFetching = false
    },
    confirmSelfcheckFailed(state, error) {
      state.error = error
      state.isFetching = false
    },
    cancelSelfcheckStart(state) {
      state.error = null
      state.isFetching = true
    },
    cancelSelfcheckDone(state) {
      state.isFetching = false
    },
    cancelSelfcheckFailed(state, error) {
      state.error = error
      state.isFetching = false
    },
    fetchSeatAmountStart(state) {
      state.error = null
      state.isFetching = true
    },
    fetchSeatAmountDone(state, payload) {
      state.checkInfos = payload.checkInfos
      state.taxAmount = payload.taxAmount
      state.amountChanged = payload.amountChangedFlg
      state.isFetching = false
    },
    fetchSeatAmountFailed(state, error) {
      state.isFetching = false
      state.error = error
    },
    callStaffSelfcheckStart(state) {
      state.error = null
      state.isFetching = true
    },
    callStaffSelfcheckDone(state) {
      state.isFetching = false
    },
    callStaffSelfcheckFailed(state, error) {
      state.isFetching = false
      state.error = error
    },
  },
}

export default selfcheck
